<template>
    <fragment>
        <c-generic-section top-divider>
            <div class="container-xs">
                <h2 class="mt-0">Thank you for joining Smart Algo!</h2>
                  <p>
                    A team member will setup access for your TradingView username within 24 hours. If you need faster support, please join the <a href="https://discord.gg/CE7fHRZmaR">Discord</a> or email us at <a href="mailto:info@smartalgo.com">info@smartalgo.com</a>.
                  </p>
            </div>
        </c-generic-section>        
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutAlternative.vue'
import CGenericSection from '@/components/sections/GenericSection.vue'

export default {
  name: 'Disclaimer',
  components: {
    CGenericSection,
  },
  data() {
    return {
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
  },
  methods: {
    rfsn_getQS : function(e) {
      // eslint-disable-next-line
      e=e.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");
      var t=new RegExp("[\\?&]"+e+"=([^&#]*)"),n=t.exec(location.search);return n==null?"":decodeURIComponent(n[1].replace(/\+/g," "))
    }, 
    _refersion : function() {
      window._rfsn._addCart(this.rfsn_getQS('rfsn_ci'));
      window._rfsn._setSource("CHARGEBEE");
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      if (this.rfsn_getQS('rfsn_ci')) {
              this._refersion();
          }
    })
  }
}
</script>